export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    }
  }
};